import { CheckboxGroup, FormCheckbox } from 'omakase';
import { SearchFiltersFieldNames } from 'components/www/availability-search/SearchHeader';
import { fieldset } from 'components/www/availability-search/filters/searchFiltersCssDefs';

const SearchFilterSeatingAreaTags: React.FunctionComponent = () => {
  return (
    <CheckboxGroup css={fieldset} disclosureMode="static" label="Seating">
      <FormCheckbox
        key="Outdoors"
        id="Outdoors"
        label="Outdoors"
        value="Outdoor"
        weight="book"
        name={SearchFiltersFieldNames.experienceTagSeatingArea}
        size="large"
      />
    </CheckboxGroup>
  );
};

export default SearchFilterSeatingAreaTags;
